import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const withEffects = WrappedComponent => {
  return props => {
    const { setErrorMessage, errorMessage } = props

    const location = useLocation()
    const { pathname, search } = location

    // just run the effect on pathname and/or search change
    useEffect(() => {
      resetError()
    }, [pathname, search])

    const resetError = () => {
      if (errorMessage != null) {
        setErrorMessage(null)
      }
    }

    return null
  }
}

export default withEffects
